import clsx from 'clsx';

import { Image } from '@/components/ui/image';
import style from './pre-approved.module.css';
import { ContactForm } from '@/components/form/contact-form';
import InfoJson from '@/config/info.json';

export function PreApproved() {
  return (
    <div
      className={clsx(
        'relative flex flex-1 w-full p-4 md:p-8 flex-col border rounded-md',
        style['pre-approved-container']
      )}
    >
      <div className="absolute -top-2 left-1 hidden md:block">
        <div className="relative h-60 w-60">
          <Image
            src="/img/buyingwith/starteddes.png"
            objectFit="contain"
            layout="fill"
            alt="Started"
          />
        </div>
      </div>
      <div className="max-w-6xl px-2 md:px-6 mx-auto my-4 md:my-8 text-center">
        <h2 className="font-extrabold text-base md:text-2xl mb-4">
          HOW DO I GET PRE-APPROVED FOR A MORTGAGE?
        </h2>
        <p className="text-sm md:text-lg mb-4">
          Get the answers you need today with our complimentary buyer’s guide!
          Complete the form here and we’ll send it you right away. To book a
          buyer’s appointment,{' '}
          <a
            className="text-primary-500"
            href={InfoJson['google-calendar']}
            target="_blank"
            rel="noreferrer"
          >
            click here
          </a>
          .
        </p>
      </div>
      <ContactForm />
    </div>
  );
}
